<template>

  <div class=" employee-tab leave-attendance-dashboard">

    <div class="col-md-10 col-sm-12 pl-0" >
      <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Geo & Device Mapping</span></h4>
    </div>

    <div class="mt-4 roster-wrapper">
    <b-tabs pills v-model="rosterTabIndex" content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">

      <b-tab lazy title="Employee Geo Locations"  v-if="$acl['geolocation/mapemployee/all'] == 2">
        <div class="">
          <employee-geo-ocations ></employee-geo-ocations>
        </div>
      </b-tab>

      <b-tab lazy title="Employee Device Data" v-if="$acl['roster/device/employee'] == 2">
        <div class="">
          <roster-device-signup  @childToParent="goToData"></roster-device-signup>
        </div>
      </b-tab>

    </b-tabs>

  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      roster: 0,
      regularization: 0,
      penalty: 0,
      overtime: 0,
      rosterTabIndex: 0,
      migratedTabIndex: 0,
      migratedHoverTab: null,
      roster_assignment_enabled: false,
    }
  },
  methods: {
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;
          this.regularization = response.data.regularization;
          this.penalty = response.data.penalty;
          this.overtime = response.data.overtime;
        }
      }.bind(this));
    },
    migratedTabStyle(index) {
      const active = this.migratedTabIndex === index;
      const hovered = this.migratedHoverTab === index;

      return {
        display: 'inline-block',
        padding: '10px 18px',
        color: active || hovered ? '#ffffff' : '#787878',
        background: active || hovered ? '#126D66' : 'transparent',
        border: 'none',
        borderRadius: '4px',
        boxShadow: active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
        cursor: 'pointer'
      };
    },
    getCount(){
      axios.get(this.$api_url + '/leave-attendance/employees/count').then(response => {
        this.roster_assignment_enabled = (response.data.roster > 0);
      })
    },
    goToData(i, msg=''){
      this.rosterTabIndex = i;
      if(msg) {
        this.$bvToast.toast(msg, {
          title: 'Success',
          variant: 'success',
          solid: true
        })
      }
    }
  },
  created() {
    this.getCount();
    this.getCompanyLeaveSettings();
  }
}
</script>
